
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/area-de-acesso",
      function () {
        return require("private-next-pages/area-de-acesso/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/area-de-acesso"])
      });
    }
  